<template>
  <div>
    <p class="text-h4 font-weight-bold" v-text="t$.title"/>
    <HTMLRender class="mt-3 text-paragraph-2" locale="sites.form.fields.domainHint.subtitle"/>
  </div>
</template>

<script>
import { HTMLRender, useLocale } from '@locaweb/design-system-vue'

export default {
  name: 'DomainBubble',
  components: {
    HTMLRender
  },
  setup () {
    return {
      t$: useLocale('sites.form.fields.domainHint')
    }
  }
}
</script>

<style scoped>

</style>
